import { BsWhatsapp } from "react-icons/bs";

function WhatsAppButton() {
  return (
    <a
      href="https://wa.me/919867672919"
      target="_blank"
      rel="noreferrer"
      className="whatsapp-btn"
    >
      <BsWhatsapp />

      <span className="whatsapp-text">Chat With Us</span>
    </a>
  );
}

export default WhatsAppButton;
